module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group my-4"
  }, [_c('label', {
    attrs: {
      "for": 'img_' + _vm.inputId
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', [_c('center', [_c('div', [_c('img', {
    staticClass: "location-photo",
    attrs: {
      "width": "50%",
      "src": _vm.value,
      "name": 'img_' + _vm.inputId,
      "id": 'img_' + _vm.inputId
    },
    on: {
      "error": _vm.imgLoadError
    }
  }), _vm._v(" "), (!_vm.hasPhoto()) ? _c('i', {
    staticClass: "fa fa-picture-o fa-5x align-content-center",
    attrs: {
      "name": 'no_img_' + _vm.inputId,
      "id": 'no_img_' + _vm.inputId
    }
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.errors.has(_vm.inputId)),
      expression: "!errors.has(inputId)"
    }],
    staticClass: "help is-invalid",
    staticStyle: {
      "display": "none",
      "color": "red"
    },
    attrs: {
      "id": 'error_' + _vm.inputId
    }
  }, [_vm._v("Invalid Image")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.inputId)),
      expression: "errors.has(inputId)"
    }],
    staticClass: "help is-invalid",
    staticStyle: {
      "display": "none",
      "color": "red"
    },
    attrs: {
      "id": 'required_' + _vm.inputId
    }
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.inputId)))])])], 1), _vm._v(" "), _c('div', [_c('input', {
    staticClass: "upload-file",
    attrs: {
      "type": "file",
      "name": 'file_' + _vm.inputId,
      "id": 'file_' + _vm.inputId
    },
    on: {
      "change": _vm.didSelectFile
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.inputId
    }
  }, [_vm._v(_vm._s(_vm.label) + " URL:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validationRule),
      expression: "validationRule"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": _vm.inputId,
      "id": _vm.inputId
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.urlUpdated($event.target.value)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77f73286"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/widgets/remote-image.vue
// module id = 558
// module chunks = 1